import _ from 'lodash'

const isTagsLoading = (state) => _.get(state, 'loading')
const tags = (state) => _.get(state, 'tags')
const errors = (state) => _.get(state, 'errors')
const tagsMeta = (state) => _.get(state, 'tagsMeta')

export default {
	isTagsLoading,
	tags,
	errors,
	tagsMeta
}
